import { Component, OnInit } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { lang_perfiles } from 'app/idiomas/i18n/perfiles/perfiles.lang';
import { lang_focus } from 'app/idiomas/i18n/focus/focus.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import { LandingService } from "app/main/pagina/landingProducto/landing/landing.service";
import * as catSecciones from 'app/main/pagina/tools/gestUsu/detail/cat-secciones';
import { ODSService } from "app/main/pagina/tools/gestUsu/services/ods.service";
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-modal-agregar-enc',
  templateUrl: './modal-agregar-enc.component.html',
  styleUrls: ['./modal-agregar-enc.component.scss']
})
export class ModalAgregarEncComponent implements OnInit {

  surveyTemplates:any[]=[]
  plantilla:any="";
  name:any="";
  instituto: string;
  institutoId: number;

  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    private landingService : LandingService,
    private odsService: ODSService,
    public dialogRef: MatDialogRef<ModalAgregarEncComponent>,
    private wizardService: WizardService,
  ) {
    lang_perfiles.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_focus.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit() {
    this.obtieneInstituto();
  }
  obtieneInstituto(){
    let institutoAct = this.wizardService.getInstituto();
    console.log(institutoAct);
    switch(institutoAct){
      case '1': case 'MX': this.instituto = 'MX'; this.institutoId=1; break;
      case '2': case 'CAyC': this.instituto = 'CAyC';this.institutoId=2; break;
      case '3': case 'HK': this.instituto = 'HK'; this.institutoId=3; break;
      case '4': case 'SGP': this.instituto = 'SGP'; this.institutoId=4;break;
      case '5': case 'TK': this.instituto = 'TK';this.institutoId=5; break;
      case '6': case 'FL': this.instituto = 'FL';this.institutoId=6; break;
      case '8': case 'IZZI': this.instituto = 'IZZI';this.institutoId=8; break;
      case '11': case 'BR': this.instituto = 'BR';this.institutoId=11; break;
      case '14': case 'GCTI': this.instituto = 'GCTI';this.institutoId=14; break;
      case '15': case 'ES': this.instituto = 'ES';this.institutoId=15; break;
    }
    this.getPlantillasFocus();
  }

agregarEncuesta(name:any,idPlantilla:any){
  let empresaId:any
  if (localStorage.getItem('instituto_correos')) {
    empresaId=localStorage.getItem('empresaID');
    console.log('entro itbm');
  }else{
   empresaId=localStorage.getItem('companyID');
   console.log('entro empresa');

  }
    this.modalGuardado();
  let data:any;
  data = {
    productoId: 43,
    fechaProducto: localStorage.getItem('fechaProducto'),
    secciones : catSecciones.seccionesFocusArea3,
    nombreProducto:'focus 1',
    nameSurvey:name,
    idPlantilla:idPlantilla,
  };
    console.log(data);
  this.odsService.matchCompanyProduct(empresaId,data).subscribe((respuesta:any) => {
    console.log(respuesta);
    let modal = 'LANDINFOCUS.MODALES.CORRECTO';
    this.translateSrv.get(modal).subscribe((res1: string) => { modal = res1; });
    Swal.close();
    this.dialogRef.close(1);
    Swal.fire({
      title: modal + name
    })
    // this.salir(idPlantilla);
  }, error => {
    console.log(error);
  });
}


 getPlantillasFocus(){
   let instituto:any
   if (localStorage.getItem('instituto_correos')) {
     instituto=localStorage.getItem('instituto_correos');
     console.log('entro itbm');
   }else{
    instituto=this.institutoId;
    console.log('entro empresa',instituto);

   }
   this.landingService.getTemplatesCertV3(instituto,'43').subscribe( (respuesta: any) => {
     console.log('respuesta,respuesta',respuesta);
this.surveyTemplates=respuesta.surveyTemplates;
   });
 }

 modalGuardado(){
   let mensaje: string;
this.translateSrv.get('LANDINFOCUS.MODALES.CREARENC').subscribe((res: string) => { mensaje = res; });

   Swal.fire({
     title: mensaje,
     allowOutsideClick: false,
     didOpen: () => {
       Swal.showLoading()
     }
   });
 }
}
